"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withPalette = withPalette;
exports.withBorderedPalette = withBorderedPalette;
exports.BORDER_OPACITY = exports.FG_COLOR = exports.PALETTE_MAPPER = void 0;

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _styledComponents = require("styled-components");

var _color = _interopRequireDefault(require("@decisiv/design-tokens/lib/color"));

var _color2 = _interopRequireDefault(require("./color"));

var _commonUIColors = require("../utils/commonUIColors");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var PALETTE_MAPPER = {
  pastel: 'light',
  bright: 'medium',
  dark: 'dark'
};
exports.PALETTE_MAPPER = PALETTE_MAPPER;
var FG_COLOR = {
  pastel: _objectSpread({}, _color.default.base.charcoal, {
    alpha: 0.8
  }),
  bright: _color.default.base.snowWhite,
  dark: _color.default.base.snowWhite
};
exports.FG_COLOR = FG_COLOR;
var BORDER_OPACITY = {
  pastel: 0.1,
  bright: 0.15,
  dark: 0.3
};
exports.BORDER_OPACITY = BORDER_OPACITY;

var colorModifiers = function colorModifiers(props) {
  var _props$palette = props.palette,
      palette = _props$palette === void 0 ? 'bright' : _props$palette,
      colorProp = props.color;

  if (colorProp && colorProp in _commonUIColors.commonUIColors) {
    var baseColor = _commonUIColors.commonUIThreeShadeColors[colorProp];
    var fgColor = FG_COLOR[palette];
    var bgColor = baseColor[PALETTE_MAPPER[palette]];
    var colorPalette = palette === 'bright' ? bgColor : _objectSpread({}, bgColor, {
      fg: fgColor
    });
    return (0, _styledComponents.css)(["", ""], (0, _color2.default)(colorPalette));
  }

  return (0, _styledComponents.css)(["", ""], (0, _color2.default)(_commonUIColors.commonUIColors.licoriceMousse));
};
/**
 * Helper to apply the palette color Interpolation
 */


function withPalette(props) {
  return (0, _styledComponents.css)(["", ""], colorModifiers(props));
}
/**
 * Helper to apply the palette color Interpolation with borders
 */


function withBorderedPalette(props) {
  var _props$palette2 = props.palette,
      palette = _props$palette2 === void 0 ? 'bright' : _props$palette2;

  var borderColor = _objectSpread({}, _color.default.base.charcoal, {
    alpha: BORDER_OPACITY[palette]
  });

  return (0, _styledComponents.css)(["", " border:1px solid ", ";"], colorModifiers(props), (0, _toColorString.default)(borderColor));
}